<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
useSeoMeta({
  title: "Juno Midwives",
  description:
    "Juno Midwives are NMC registered, independent midwives, with over 22 years combined experience and a passion for providing personalised midwifery care",
  ogTitle: "Juno Midwives",
  ogDescription: "Independent Midwives in Kent",
  ogImage: "https://junomidwives.co.uk/og-image.png",
});
</script>
